<template>
    <v-card
        class="pa-3 d-flex flex-column"
        style="height: 100%; min-width: 300px"
    >
        <v-card-title class="card-title">{{ title }}</v-card-title>
        <v-card-subtitle class="pb-2 text-typography2" opacity="1">
            {{ subtitle }}
            <v-row class="mt-1">
                <v-col cols="12" class="py-0 d-flex flex-wrap">
                    <v-chip
                        v-for="d in discipline"
                        :key="d"
                        class="me-2 mt-2"
                        color="primary"
                        variant="outlined"
                        label
                        size="small"
                    >
                        {{ d }}
                    </v-chip>
                    <v-chip
                        v-for="r in region"
                        :key="r"
                        class="me-2 mt-2"
                        color="secondary"
                        variant="outlined"
                        label
                        size="small"
                    >
                        {{ r }}
                    </v-chip>
                </v-col>
            </v-row>
        </v-card-subtitle>
        <v-spacer></v-spacer>
        <v-card-text>
            <v-row>
                <v-col xs="12" sm="6" cols="12">
                    <v-img
                        contain
                        aspect-ratio="1"
                        height="100%"
                        max-height="250"
                        :src="imageUrl"
                    >
                    </v-img>
                </v-col>
                <v-col xs="12" sm="6" cols="12"
                    ><v-card
                        elevation="0"
                        max-height="250"
                        class="overflow-auto styled-scrollbar"
                    >
                        <v-card-text>
                            <span v-html="description"></span>
                        </v-card-text> </v-card
                ></v-col>
            </v-row>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
            <v-row class="d-flex align-end">
                <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                    <v-btn
                        v-if="uuid !== 'NO_CALC'"
                        class="me-1 text-uppercase text-label-large px-4"
                        @click="linkToCalc"
                        variant="elevated"
                        color="primary"
                    >
                        {{ mainLink.title }}
                    </v-btn>
                    <v-btn
                        v-else
                        class="me-1 text-uppercase text-label-large px-4"
                        :href="mailTo"
                        variant="elevated"
                        color="primary"
                    >
                        {{ mainLink.title }}
                    </v-btn>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    md="6"
                    lg="6"
                    xl="6"
                    v-if="additionalLinks && additionalLinks.length > 0"
                >
                    <v-menu rounded="lg">
                        <template v-slot:activator="{ props: propsMenu }">
                            <v-btn variant="elevated" v-bind="propsMenu"
                                >Additional links</v-btn
                            >
                        </template>
                        <v-list>
                            <v-list-item
                                link
                                v-for="link in additionalLinks"
                                :key="link.title"
                                :href="link.link"
                                target="_blank"
                            >
                                <v-tooltip location="top" v-if="link.tooltip">
                                    <template
                                        v-slot:activator="{ props: propsTool }"
                                    >
                                        <v-list-item-title v-bind="propsTool">
                                            <span>{{ link.title }}</span>
                                        </v-list-item-title>
                                    </template>
                                    {{ link.tooltip }}
                                </v-tooltip>
                                <v-list-item-title v-else>
                                    <span>{{ link.title }}</span>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
                <v-spacer />
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'

const adImages = import.meta.glob('../../../assets/ads/*', {
    eager: true,
    import: 'default',
})

const props = defineProps({
    calc: { type: Object, required: true },
    index: { type: Number, required: true },
})

const { proxy } = getCurrentInstance()
const router = useRouter()

const mailTo = computed(() => props.calc.mailTo)
const uuid = computed(() => props.calc.uuid)
const region = computed(() => props.calc.region)
const discipline = computed(() => props.calc.discipline)
const title = computed(() => props.calc.title)
const subtitle = computed(() => props.calc.subtitle)
const description = computed(() => props.calc.description)
const mainLink = computed(() => props.calc.mainLink)
const additionalLinks = computed(() => props.calc.additional_links)
const imageUrl = computed(
    () =>
        adImages[`../../../assets/ads/${props.calc.image}`] ??
        adImages['../../../assets/ads/backup.png']
)

function linkToCalc() {
    const link = mainLink.value.link
    if (proxy.$posthog) {
        proxy.$posthog.capture('adClick', {
            location: 'homepage',
            calc: props.calc,
            index: props.index,
        })
    }
    router.push(link)
}
</script>
<style scoped>
.card-title {
    font-size: 1.25rem;
    font-weight: 500;
}
</style>
